import { render, staticRenderFns } from "./ForbiddenGoodsModule.vue?vue&type=template&id=706f8d05"
import script from "./ForbiddenGoodsModule.vue?vue&type=script&lang=js"
export * from "./ForbiddenGoodsModule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports